import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-timerange', 'TIME_START', 'Time start');
Labels.set('ui-timerange', 'TIME_END', 'Time end');
